import { Person } from '@/components/business/person-column'
import { MarketShopTransactionModel } from '@/models/features/market-shop.models'

// Note: the ordering resident of a restaurant order. The split fields come with BE EL-15927; a
// backend without them only sends `residentName`, which is kept as the name so the column never
// loses it (it showed the name before EL-15064)
export const getMarketShopResident = (transaction: MarketShopTransactionModel): Person | null => {
  if (transaction.residentFirstName || transaction.residentLastName) {
    return {
      apartment: transaction.residentApartment,
      avatar: transaction.residentAvatar,
      buildingNumber: transaction.residentBuildingNumber,
      clientId: transaction.clientId,
      email: transaction.residentEmail,
      firstName: transaction.residentFirstName,
      kind: 'resident',
      lastName: transaction.residentLastName,
      phone: transaction.residentPhone,
      street: transaction.residentStreet,
    }
  }

  const name = transaction.residentName?.trim()
  return name ? { clientId: transaction.clientId, firstName: name, kind: 'resident' } : null
}
